import { render, staticRenderFns } from "./CuInput.vue?vue&type=template&id=0672dc96"
import script from "./CuInput.vue?vue&type=script&lang=js"
export * from "./CuInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports